import React from 'react';
import { Box, ButtonV2, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { MapLocation } from '../../Map/Map.types';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { JoyInteractableMap } from '@shared/components/JoyInteractableMap';
import { JoyInteractableMapProvider } from '@shared/components/JoyInteractableMap/JoyInteractableMap.provider';
import { DEFAULT_ZOOM } from '../../Map/Map.constants';
import { useTranslation } from '@shared/core';

type CompactMapProps = Readonly<{
  location: MapLocation | null;
  onShowOnMap: () => void;
}>;

export const CompactMap: React.FC<CompactMapProps> = ({ location, onShowOnMap }) => {
  const { tq } = useTranslation('accommodationsConsole');
  const handleShowOnMap = useEventCallback(() => {
    onShowOnMap();
  });

  if (!location) {
    return null;
  }

  return (
    <Box
      position="relative"
      width="100%"
      height={pxToRem(192)}
      borderRadius={3}
      overflow="hidden"
      marginBottom={6}
      aria-hidden="true"
    >
      <JoyInteractableMapProvider>
        <JoyInteractableMap
          center={location.latlng}
          zoom={DEFAULT_ZOOM}
          gestureHandling="none"
        />
      </JoyInteractableMapProvider>
      <Flex
        position="absolute"
        bottom={4}
        left="50%"
        transform="translateX(-50%)"
        zIndex="docked"
        aria-hidden="false"
      >
        <ButtonV2
          variant="outline"
          intent="neutral"
          shape="rounded"
          backgroundColor="white"
          borderColor="mono3"
          onClick={handleShowOnMap}
          aria-label={location.place ? tq`Show ${location.place} on Map` : tq`Show on Map`}
          _hover={{
            backgroundColor: 'white',
            borderColor: 'mono4',
          }}
        >
          {tq`Show on Map`}
        </ButtonV2>
      </Flex>
    </Box>
  );
};
